import { ActionTypes, State } from './types';

const initialState: State = {
  conditionEditor: {
    editedConditionId: null
  }
};

const questionnaireReducer = (state: State = initialState, action: any): State => {
  switch (action.type) {
    case ActionTypes.SET_EDITED_CONDITION_ID:
      return {
        ...state,
        conditionEditor: {
          ...state.conditionEditor,
          editedConditionId: action.payload
        }
      };

    default:
      return state;
  }
};

export default questionnaireReducer;
